<section class="section-50">
  <div class="container">
    <h1 class="text-muted notification-header">Notifications
      <mat-icon class="text-muted">notifications</mat-icon>
    </h1>
    <mat-tab-group (selectedTabChange)="tabChange()">
      <mat-tab label="New">
        @if (notifications.length == 0) {
          <h3 class="mt-2 notification-header">No New Notifications</h3>
        }
        @for (notification of notifications; track notification) {
          <div class="notification-ui_dd-content mt-3">
            <div class="notification-list-new">
              <div class="notification-list_content">
                <div class="notification-list_detail">
                  <p><b>New Message</b></p>
                  <p class="text-muted">{{notification.message}}</p>
                  <p class="text-muted"><small>Date of Notification: {{notification.createDateUTC | date:'shortDate'}}</small></p>
                  <p>
                    <mat-checkbox 
                      class="text-muted" 
                      style="font-size: 8pt;" 
                      color="primary" 
                      (change)="updateNotification(notification)" 
                      [checked]="notification.isRead"
                    >
                    <div class="mt-2">Viewed</div>
                  </mat-checkbox>
                  </p>
                </div>
              </div>
            </div>
          </div>
        }
        <footer class="mb-5">
          <button mat-raised-button class="mb-5 mt-3" style="border-radius: 4px" [hidden]="!moreNotificationsToLoad" (click)="loadMoreNotifications()" color="primary">Load More</button>
        </footer>
      </mat-tab>
      <mat-tab label="Old">
        @if (notifications.length == 0) {
          <h3 class="mt-2">No Old Notifications</h3>
        }
        @for (notification of notifications; track notification) {
          <div class="notification-ui_dd-content mt-3">
            <div class="notification-list-old">
              <div class="notification-list_content">
                <div class="notification-list_detail">
                  <p class="text-muted">{{notification.message}}</p>
                  <p class="text-muted"><small>Date of Notification: {{notification.createDateUTC | date:'shortDate'}}</small></p>
                  <p>
                    <mat-checkbox class="text-muted" style="font-size: 8pt;" color="primary" [checked]="!notification.isRead" (change)="updateNotification(notification)"
                    >
                    <div class="mt-2">Mark As New</div>
                    </mat-checkbox>
                  </p>
                </div>
              </div>
            </div>
          </div>
        }
        <footer class="mb-5">
          <button mat-raised-button class="mb-5 mt-3" style="border-radius: 4px" [hidden]="!moreNotificationsToLoad" (click)="loadMoreNotifications()" color="primary">Load More</button>
        </footer>
      </mat-tab>
    </mat-tab-group>
  </div>
</section>